import { render } from "./App.vue?vue&type=template&id=170f0795&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=170f0795&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\user\\Desktop\\production\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170f0795"]])

export default __exports__